//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getHealth(): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthStatus>(null as any);
    }
}

export class ProductCarrierClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getProducts(isActive: boolean | null | undefined): Promise<ProductInfoResponse[]> {
        let url_ = this.baseUrl + "/ProductCarrier/products?";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: Response): Promise<ProductInfoResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfoResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductInfoResponse[]>(null as any);
    }

    getCarriers(isActive: boolean | null | undefined): Promise<CarrierInfoResponse[]> {
        let url_ = this.baseUrl + "/ProductCarrier/carriers?";
        if (isActive !== undefined && isActive !== null)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarriers(_response);
        });
    }

    protected processGetCarriers(response: Response): Promise<CarrierInfoResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CarrierInfoResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CarrierInfoResponse[]>(null as any);
    }
}

export class SaleInsertClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    insertSale(r: SaleInsertRequest): Promise<EnsSaleResponse> {
        let url_ = this.baseUrl + "/SaleInsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(r);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertSale(_response);
        });
    }

    protected processInsertSale(response: Response): Promise<EnsSaleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsSaleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsSaleResponse>(null as any);
    }
}

export class SaleMassUpdateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUploadUrl(): Promise<PreSignedUrlResponse> {
        let url_ = this.baseUrl + "/SaleMassUpdate/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadUrl(_response);
        });
    }

    protected processGetUploadUrl(response: Response): Promise<PreSignedUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreSignedUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSignedUrlResponse>(null as any);
    }

    processReport(guid: string): Promise<SaleMassUpdateJob> {
        let url_ = this.baseUrl + "/SaleMassUpdate/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessReport(_response);
        });
    }

    protected processProcessReport(response: Response): Promise<SaleMassUpdateJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaleMassUpdateJob.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleMassUpdateJob>(null as any);
    }
}

export class SaleNoteHistoryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAllSaleNotes(ensSaleTid: number): Promise<SaleNotesObject[]> {
        let url_ = this.baseUrl + "/SaleNoteHistory/{ensSaleTid}";
        if (ensSaleTid === undefined || ensSaleTid === null)
            throw new globalThis.Error("The parameter 'ensSaleTid' must be defined.");
        url_ = url_.replace("{ensSaleTid}", encodeURIComponent("" + ensSaleTid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSaleNotes(_response);
        });
    }

    protected processGetAllSaleNotes(response: Response): Promise<SaleNotesObject[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SaleNotesObject.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleNotesObject[]>(null as any);
    }

    insertSaleNote(request: InsertSaleNoteRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/SaleNoteHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInsertSaleNote(_response);
        });
    }

    protected processInsertSaleNote(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class SalePledgeJobClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUploadUrl(): Promise<PreSignedUrlResponse> {
        let url_ = this.baseUrl + "/SalePledgeJob/upload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUploadUrl(_response);
        });
    }

    protected processGetUploadUrl(response: Response): Promise<PreSignedUrlResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreSignedUrlResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PreSignedUrlResponse>(null as any);
    }

    processReport(guid: string): Promise<SalePledgeJob> {
        let url_ = this.baseUrl + "/SalePledgeJob/{guid}";
        if (guid === undefined || guid === null)
            throw new globalThis.Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processProcessReport(_response);
        });
    }

    protected processProcessReport(response: Response): Promise<SalePledgeJob> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalePledgeJob.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalePledgeJob>(null as any);
    }
}

export class SalePolicyHistoryClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    updatePolicyHistory(ensSaleCarrierPolicyHistoryTid: number | undefined, request: SalePolicyHistoryUpdateRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/SalePolicyHistory/update?";
        if (ensSaleCarrierPolicyHistoryTid === null)
            throw new globalThis.Error("The parameter 'ensSaleCarrierPolicyHistoryTid' cannot be null.");
        else if (ensSaleCarrierPolicyHistoryTid !== undefined)
            url_ += "ensSaleCarrierPolicyHistoryTid=" + encodeURIComponent("" + ensSaleCarrierPolicyHistoryTid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdatePolicyHistory(_response);
        });
    }

    protected processUpdatePolicyHistory(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPolicyHistory(ensSaleTid: number | undefined): Promise<SalePolicyHistoryResponse[]> {
        let url_ = this.baseUrl + "/SalePolicyHistory?";
        if (ensSaleTid === null)
            throw new globalThis.Error("The parameter 'ensSaleTid' cannot be null.");
        else if (ensSaleTid !== undefined)
            url_ += "ensSaleTid=" + encodeURIComponent("" + ensSaleTid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyHistory(_response);
        });
    }

    protected processGetPolicyHistory(response: Response): Promise<SalePolicyHistoryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalePolicyHistoryResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalePolicyHistoryResponse[]>(null as any);
    }

    deletePolicyHistory(ensSaleCarrierPolicyHistoryTid: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/SalePolicyHistory/delete?";
        if (ensSaleCarrierPolicyHistoryTid === null)
            throw new globalThis.Error("The parameter 'ensSaleCarrierPolicyHistoryTid' cannot be null.");
        else if (ensSaleCarrierPolicyHistoryTid !== undefined)
            url_ += "ensSaleCarrierPolicyHistoryTid=" + encodeURIComponent("" + ensSaleCarrierPolicyHistoryTid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeletePolicyHistory(_response);
        });
    }

    protected processDeletePolicyHistory(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateSalePolicyNumber(request: SalePolicyUpdateRequest): Promise<SalePolicyUpdateResponse> {
        let url_ = this.baseUrl + "/SalePolicyHistory/policy/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSalePolicyNumber(_response);
        });
    }

    protected processUpdateSalePolicyNumber(response: Response): Promise<SalePolicyUpdateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalePolicyUpdateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalePolicyUpdateResponse>(null as any);
    }
}

export class SalesStatusClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    searchSales(request: SalesStatusSearchRequest): Promise<SaleStatus[]> {
        let url_ = this.baseUrl + "/SalesStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSales(_response);
        });
    }

    protected processSearchSales(response: Response): Promise<SaleStatus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SaleStatus.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SaleStatus[]>(null as any);
    }

    updateSale(r: SaleUpdateRequest): Promise<EnsSaleResponse> {
        let url_ = this.baseUrl + "/SalesStatus/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(r);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSale(_response);
        });
    }

    protected processUpdateSale(response: Response): Promise<EnsSaleResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnsSaleResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EnsSaleResponse>(null as any);
    }
}

export class SaleStatusUpdateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    updateSaleStatus(ensSaleTid: number, request: SaleStatusUpdateRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/SaleStatusUpdate/{ensSaleTid}/update";
        if (ensSaleTid === undefined || ensSaleTid === null)
            throw new globalThis.Error("The parameter 'ensSaleTid' must be defined.");
        url_ = url_.replace("{ensSaleTid}", encodeURIComponent("" + ensSaleTid));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSaleStatus(_response);
        });
    }

    protected processUpdateSaleStatus(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    updateSaleStatusBulk(requests: SaleStatusUpdateRequestBulk[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/SaleStatusUpdate/update-bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requests);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSaleStatusBulk(_response);
        });
    }

    protected processUpdateSaleStatusBulk(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UnderwritingStatusClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUnderwritingStatuses(): Promise<UnderwritingStatusResponse[]> {
        let url_ = this.baseUrl + "/UnderwritingStatus/underwriting-statuses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnderwritingStatuses(_response);
        });
    }

    protected processGetUnderwritingStatuses(response: Response): Promise<UnderwritingStatusResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnderwritingStatusResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnderwritingStatusResponse[]>(null as any);
    }
}

export class HealthStatus implements IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.service = _data["service"];
            this.buildEnvironment = _data["buildEnvironment"];
            this.database = _data["database"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["service"] = this.service;
        data["buildEnvironment"] = this.buildEnvironment;
        data["database"] = this.database;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : undefined as any;
        return data;
    }
}

export interface IHealthStatus {
    service?: string | undefined;
    buildEnvironment?: string | undefined;
    database?: string | undefined;
    requestDateUtc?: Date;
}

export class ProductInfoResponse implements IProductInfoResponse {
    ensProductTid!: number;
    productName!: string;
    activeFl?: boolean | undefined;

    constructor(data?: IProductInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensProductTid = _data["ensProductTid"];
            this.productName = _data["productName"];
            this.activeFl = _data["activeFl"];
        }
    }

    static fromJS(data: any): ProductInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensProductTid"] = this.ensProductTid;
        data["productName"] = this.productName;
        data["activeFl"] = this.activeFl;
        return data;
    }
}

export interface IProductInfoResponse {
    ensProductTid: number;
    productName: string;
    activeFl?: boolean | undefined;
}

export class CarrierInfoResponse implements ICarrierInfoResponse {
    ensProductCarrierTid!: number;
    productCarrierName!: string;
    productCarrierAbbreviation!: string;
    activeFl?: boolean | undefined;

    constructor(data?: ICarrierInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensProductCarrierTid = _data["ensProductCarrierTid"];
            this.productCarrierName = _data["productCarrierName"];
            this.productCarrierAbbreviation = _data["productCarrierAbbreviation"];
            this.activeFl = _data["activeFl"];
        }
    }

    static fromJS(data: any): CarrierInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CarrierInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensProductCarrierTid"] = this.ensProductCarrierTid;
        data["productCarrierName"] = this.productCarrierName;
        data["productCarrierAbbreviation"] = this.productCarrierAbbreviation;
        data["activeFl"] = this.activeFl;
        return data;
    }
}

export interface ICarrierInfoResponse {
    ensProductCarrierTid: number;
    productCarrierName: string;
    productCarrierAbbreviation: string;
    activeFl?: boolean | undefined;
}

export class EnsSaleResponse implements IEnsSaleResponse {
    ensSaleTid?: number;
    purchaserLastEnsContactMarketingActionTid?: number;
    purchaserEnsContactTid?: number;
    insuredEnsContactTid?: number;
    ensProductCarrierTid?: number;
    ensProductTid?: number;
    agentEnsUserTid?: number;
    referralEnsUserTid?: number | undefined;
    f9WorksheetTid?: number;
    saleDatetime?: Date;
    effectiveDate?: Date;
    ageAtTos?: number;
    premium?: number | undefined;
    premiumMultiplier?: number | undefined;
    rewriteFl?: boolean;
    referralAgentAnswer?: string | undefined;
    policyNumber?: string | undefined;
    commissionBasis?: string | undefined;
    notes?: string | undefined;
    underwritingComments?: string | undefined;
    insuredFirstName?: string | undefined;
    insuredLastName?: string | undefined;
    insuredGender?: string | undefined;
    insuredDob?: Date | undefined;
    insuredPhone?: string | undefined;
    insuredEmail?: string | undefined;
    insuredAddressLine1?: string | undefined;
    insuredAddressLine2?: string | undefined;
    insuredCity?: string | undefined;
    insuredState?: string | undefined;
    insuredZip?: string | undefined;
    approvalDatetime?: Date | undefined;
    currentEnsSaleStatusTid?: number;
    issueEnsSaleStatusTid?: number;
    terminationDate?: Date | undefined;
    ensSaleUnderwritingStatusTid?: number | undefined;
    ensMarketingCampaignTid?: number | undefined;

    constructor(data?: IEnsSaleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleTid = _data["ensSaleTid"];
            this.purchaserLastEnsContactMarketingActionTid = _data["purchaserLastEnsContactMarketingActionTid"];
            this.purchaserEnsContactTid = _data["purchaserEnsContactTid"];
            this.insuredEnsContactTid = _data["insuredEnsContactTid"];
            this.ensProductCarrierTid = _data["ensProductCarrierTid"];
            this.ensProductTid = _data["ensProductTid"];
            this.agentEnsUserTid = _data["agentEnsUserTid"];
            this.referralEnsUserTid = _data["referralEnsUserTid"];
            this.f9WorksheetTid = _data["f9WorksheetTid"];
            this.saleDatetime = _data["saleDatetime"] ? new Date(_data["saleDatetime"].toString()) : undefined as any;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.ageAtTos = _data["ageAtTos"];
            this.premium = _data["premium"];
            this.premiumMultiplier = _data["premiumMultiplier"];
            this.rewriteFl = _data["rewriteFl"];
            this.referralAgentAnswer = _data["referralAgentAnswer"];
            this.policyNumber = _data["policyNumber"];
            this.commissionBasis = _data["commissionBasis"];
            this.notes = _data["notes"];
            this.underwritingComments = _data["underwritingComments"];
            this.insuredFirstName = _data["insuredFirstName"];
            this.insuredLastName = _data["insuredLastName"];
            this.insuredGender = _data["insuredGender"];
            this.insuredDob = _data["insuredDob"] ? new Date(_data["insuredDob"].toString()) : undefined as any;
            this.insuredPhone = _data["insuredPhone"];
            this.insuredEmail = _data["insuredEmail"];
            this.insuredAddressLine1 = _data["insuredAddressLine1"];
            this.insuredAddressLine2 = _data["insuredAddressLine2"];
            this.insuredCity = _data["insuredCity"];
            this.insuredState = _data["insuredState"];
            this.insuredZip = _data["insuredZip"];
            this.approvalDatetime = _data["approvalDatetime"] ? new Date(_data["approvalDatetime"].toString()) : undefined as any;
            this.currentEnsSaleStatusTid = _data["currentEnsSaleStatusTid"];
            this.issueEnsSaleStatusTid = _data["issueEnsSaleStatusTid"];
            this.terminationDate = _data["terminationDate"] ? new Date(_data["terminationDate"].toString()) : undefined as any;
            this.ensSaleUnderwritingStatusTid = _data["ensSaleUnderwritingStatusTid"];
            this.ensMarketingCampaignTid = _data["ensMarketingCampaignTid"];
        }
    }

    static fromJS(data: any): EnsSaleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EnsSaleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleTid"] = this.ensSaleTid;
        data["purchaserLastEnsContactMarketingActionTid"] = this.purchaserLastEnsContactMarketingActionTid;
        data["purchaserEnsContactTid"] = this.purchaserEnsContactTid;
        data["insuredEnsContactTid"] = this.insuredEnsContactTid;
        data["ensProductCarrierTid"] = this.ensProductCarrierTid;
        data["ensProductTid"] = this.ensProductTid;
        data["agentEnsUserTid"] = this.agentEnsUserTid;
        data["referralEnsUserTid"] = this.referralEnsUserTid;
        data["f9WorksheetTid"] = this.f9WorksheetTid;
        data["saleDatetime"] = this.saleDatetime ? this.saleDatetime.toISOString() : undefined as any;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["ageAtTos"] = this.ageAtTos;
        data["premium"] = this.premium;
        data["premiumMultiplier"] = this.premiumMultiplier;
        data["rewriteFl"] = this.rewriteFl;
        data["referralAgentAnswer"] = this.referralAgentAnswer;
        data["policyNumber"] = this.policyNumber;
        data["commissionBasis"] = this.commissionBasis;
        data["notes"] = this.notes;
        data["underwritingComments"] = this.underwritingComments;
        data["insuredFirstName"] = this.insuredFirstName;
        data["insuredLastName"] = this.insuredLastName;
        data["insuredGender"] = this.insuredGender;
        data["insuredDob"] = this.insuredDob ? this.insuredDob.toISOString() : undefined as any;
        data["insuredPhone"] = this.insuredPhone;
        data["insuredEmail"] = this.insuredEmail;
        data["insuredAddressLine1"] = this.insuredAddressLine1;
        data["insuredAddressLine2"] = this.insuredAddressLine2;
        data["insuredCity"] = this.insuredCity;
        data["insuredState"] = this.insuredState;
        data["insuredZip"] = this.insuredZip;
        data["approvalDatetime"] = this.approvalDatetime ? this.approvalDatetime.toISOString() : undefined as any;
        data["currentEnsSaleStatusTid"] = this.currentEnsSaleStatusTid;
        data["issueEnsSaleStatusTid"] = this.issueEnsSaleStatusTid;
        data["terminationDate"] = this.terminationDate ? this.terminationDate.toISOString() : undefined as any;
        data["ensSaleUnderwritingStatusTid"] = this.ensSaleUnderwritingStatusTid;
        data["ensMarketingCampaignTid"] = this.ensMarketingCampaignTid;
        return data;
    }
}

export interface IEnsSaleResponse {
    ensSaleTid?: number;
    purchaserLastEnsContactMarketingActionTid?: number;
    purchaserEnsContactTid?: number;
    insuredEnsContactTid?: number;
    ensProductCarrierTid?: number;
    ensProductTid?: number;
    agentEnsUserTid?: number;
    referralEnsUserTid?: number | undefined;
    f9WorksheetTid?: number;
    saleDatetime?: Date;
    effectiveDate?: Date;
    ageAtTos?: number;
    premium?: number | undefined;
    premiumMultiplier?: number | undefined;
    rewriteFl?: boolean;
    referralAgentAnswer?: string | undefined;
    policyNumber?: string | undefined;
    commissionBasis?: string | undefined;
    notes?: string | undefined;
    underwritingComments?: string | undefined;
    insuredFirstName?: string | undefined;
    insuredLastName?: string | undefined;
    insuredGender?: string | undefined;
    insuredDob?: Date | undefined;
    insuredPhone?: string | undefined;
    insuredEmail?: string | undefined;
    insuredAddressLine1?: string | undefined;
    insuredAddressLine2?: string | undefined;
    insuredCity?: string | undefined;
    insuredState?: string | undefined;
    insuredZip?: string | undefined;
    approvalDatetime?: Date | undefined;
    currentEnsSaleStatusTid?: number;
    issueEnsSaleStatusTid?: number;
    terminationDate?: Date | undefined;
    ensSaleUnderwritingStatusTid?: number | undefined;
    ensMarketingCampaignTid?: number | undefined;
}

export class SaleInsertRequest implements ISaleInsertRequest {
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid!: EnsProductCarrierTid;
    ens_product_tid!: EnsProduct;
    agent_ens_user_tid!: number;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    current_ens_sale_status_tid!: number;
    issued_ens_sale_status_tid!: number;
    sale_datetime!: Date;
    effective_date!: Date;
    age_at_tos?: number | undefined;
    rewrite_fl!: boolean;
    premium?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    premium_multiplier?: number | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob!: Date;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    medicare_id?: string | undefined;

    constructor(data?: ISaleInsertRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaser_last_ens_contact_marketing_action_tid = _data["purchaser_last_ens_contact_marketing_action_tid"];
            this.purchaser_ens_contact_id = _data["purchaser_ens_contact_id"];
            this.insured_ens_contact_tid = _data["insured_ens_contact_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_product_tid = _data["ens_product_tid"];
            this.agent_ens_user_tid = _data["agent_ens_user_tid"];
            this.referral_ens_user_tid = _data["referral_ens_user_tid"];
            this.f9_worksheet_tid = _data["f9_worksheet_tid"];
            this.current_ens_sale_status_tid = _data["current_ens_sale_status_tid"];
            this.issued_ens_sale_status_tid = _data["issued_ens_sale_status_tid"];
            this.sale_datetime = _data["sale_datetime"] ? new Date(_data["sale_datetime"].toString()) : undefined as any;
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : undefined as any;
            this.age_at_tos = _data["age_at_tos"];
            this.rewrite_fl = _data["rewrite_fl"];
            this.premium = _data["premium"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.premium_multiplier = _data["premium_multiplier"];
            this.referral_agent_answer = _data["referral_agent_answer"];
            this.primary_policy_number = _data["primary_policy_number"];
            this.commission_basis = _data["commission_basis"];
            this.notes = _data["notes"];
            this.underwriting_comments = _data["underwriting_comments"];
            this.insured_first_name = _data["insured_first_name"];
            this.insured_last_name = _data["insured_last_name"];
            this.insured_gender = _data["insured_gender"];
            this.insured_dob = _data["insured_dob"] ? new Date(_data["insured_dob"].toString()) : undefined as any;
            this.insured_phone = _data["insured_phone"];
            this.insured_email = _data["insured_email"];
            this.insured_address_line1 = _data["insured_address_line1"];
            this.insured_address_line2 = _data["insured_address_line2"];
            this.insured_city = _data["insured_city"];
            this.insured_state = _data["insured_state"];
            this.insured_zip = _data["insured_zip"];
            this.approval_datetime = _data["approval_datetime"] ? new Date(_data["approval_datetime"].toString()) : undefined as any;
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : undefined as any;
            this.ens_sale_underwritting_status_tid = _data["ens_sale_underwritting_status_tid"];
            this.medicare_id = _data["medicare_id"];
        }
    }

    static fromJS(data: any): SaleInsertRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaleInsertRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaser_last_ens_contact_marketing_action_tid"] = this.purchaser_last_ens_contact_marketing_action_tid;
        data["purchaser_ens_contact_id"] = this.purchaser_ens_contact_id;
        data["insured_ens_contact_tid"] = this.insured_ens_contact_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_product_tid"] = this.ens_product_tid;
        data["agent_ens_user_tid"] = this.agent_ens_user_tid;
        data["referral_ens_user_tid"] = this.referral_ens_user_tid;
        data["f9_worksheet_tid"] = this.f9_worksheet_tid;
        data["current_ens_sale_status_tid"] = this.current_ens_sale_status_tid;
        data["issued_ens_sale_status_tid"] = this.issued_ens_sale_status_tid;
        data["sale_datetime"] = this.sale_datetime ? this.sale_datetime.toISOString() : undefined as any;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : undefined as any;
        data["age_at_tos"] = this.age_at_tos;
        data["rewrite_fl"] = this.rewrite_fl;
        data["premium"] = this.premium;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["premium_multiplier"] = this.premium_multiplier;
        data["referral_agent_answer"] = this.referral_agent_answer;
        data["primary_policy_number"] = this.primary_policy_number;
        data["commission_basis"] = this.commission_basis;
        data["notes"] = this.notes;
        data["underwriting_comments"] = this.underwriting_comments;
        data["insured_first_name"] = this.insured_first_name;
        data["insured_last_name"] = this.insured_last_name;
        data["insured_gender"] = this.insured_gender;
        data["insured_dob"] = this.insured_dob ? this.insured_dob.toISOString() : undefined as any;
        data["insured_phone"] = this.insured_phone;
        data["insured_email"] = this.insured_email;
        data["insured_address_line1"] = this.insured_address_line1;
        data["insured_address_line2"] = this.insured_address_line2;
        data["insured_city"] = this.insured_city;
        data["insured_state"] = this.insured_state;
        data["insured_zip"] = this.insured_zip;
        data["approval_datetime"] = this.approval_datetime ? this.approval_datetime.toISOString() : undefined as any;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : undefined as any;
        data["ens_sale_underwritting_status_tid"] = this.ens_sale_underwritting_status_tid;
        data["medicare_id"] = this.medicare_id;
        return data;
    }
}

export interface ISaleInsertRequest {
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid: EnsProductCarrierTid;
    ens_product_tid: EnsProduct;
    agent_ens_user_tid: number;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    current_ens_sale_status_tid: number;
    issued_ens_sale_status_tid: number;
    sale_datetime: Date;
    effective_date: Date;
    age_at_tos?: number | undefined;
    rewrite_fl: boolean;
    premium?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    premium_multiplier?: number | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob: Date;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    medicare_id?: string | undefined;
}

export enum EnsProductCarrierTid {
    None = 0,
    GenericNotSpecified = 1,
    Aaa = 2,
    Aetna = 3,
    Ameritas = 4,
    CatholicLife = 5,
    Cigna = 6,
    Humana = 7,
    LibertyBankers = 8,
    MutualOfOmaha = 9,
    NationalHealthInsuranceCompanyNhic = 10,
    Renaissance = 11,
    Sentinel = 12,
    SilverScript = 13,
    Thrivent = 14,
    Ihc = 15,
    Sagicor = 16,
    Securian = 17,
    Hp1 = 18,
    Surebridge = 19,
    AnicoOfNy = 20,
    Anico = 21,
    HarvardPilgrim = 24,
    Gerber = 25,
    Anthem = 26,
    Cdphp = 28,
    Aig = 29,
    UnitedHealthcare = 30,
    WellCare = 31,
    SunFire = 32,
    PanAmerican = 33,
    AgentE = 34,
    PeoplesHealth = 35,
    ChoicePolicy = 36,
    Aarp = 37,
    Accendo = 39,
    ContinentalLife = 40,
    BlueCrossBlueShield = 41,
    Aflac = 42,
    Allina = 43,
    TierOne = 45,
    PhysiciansMutual = 46,
    Unknown = -1,
}

export enum EnsProduct {
    None = 0,
    Unspecfied = 1,
    AaaMembership = 2,
    AdD = 3,
    CremationProduct = 4,
    CriticalIllness = 5,
    DentalVisionCombo = 6,
    DentalVisionHearingCombo = 7,
    Dental = 8,
    DisabilityIncome = 9,
    FinalExpense = 10,
    HospitalIndemnity = 11,
    MaSpecialNeedsPlans = 12,
    Ma = 13,
    Mapd = 14,
    MedSuppPlanA = 15,
    MedSuppPlanB = 16,
    MedSuppPlanC = 17,
    MedSuppPlanD = 18,
    MedSuppPlanF = 19,
    MedSuppPlanG = 20,
    MedSuppPlanHdf = 21,
    MedSuppPlanHdg = 22,
    MedSuppPlanK = 23,
    MedSuppPlanL = 24,
    MedSuppPlanM = 25,
    MedSuppPlanN = 26,
    MetalGap = 27,
    Pdp = 28,
    ShortTermMedical = 29,
    SimplifiedIssueTerm = 30,
    Vision = 31,
    Dsnp = 32,
    MedicareCore = 33,
    MedicareSupplement = 34,
    AssociationPackage = 35,
    Cancer = 36,
    CancerHeartCombo = 37,
    Heart = 38,
    IndemnityPlan = 39,
    Life = 40,
    Term = 41,
    Generic = 43,
    OsbDental = 47,
    OsbVision = 48,
    OsbFitness = 49,
    OsbCombo = 50,
    MaChronicConditionSpecialNeedsPlan = 51,
    MedSuppPlanHdn = 52,
    Error = -1,
}

export class PreSignedUrlResponse implements IPreSignedUrlResponse {
    presignedUrl!: string;
    objectPrefix!: string | undefined;
    objectGuid!: string;

    constructor(data?: IPreSignedUrlResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.presignedUrl = _data["presignedUrl"];
            this.objectPrefix = _data["objectPrefix"];
            this.objectGuid = _data["objectGuid"];
        }
    }

    static fromJS(data: any): PreSignedUrlResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PreSignedUrlResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["presignedUrl"] = this.presignedUrl;
        data["objectPrefix"] = this.objectPrefix;
        data["objectGuid"] = this.objectGuid;
        return data;
    }
}

export interface IPreSignedUrlResponse {
    presignedUrl: string;
    objectPrefix: string | undefined;
    objectGuid: string;
}

export class SaleMassUpdateJob implements ISaleMassUpdateJob {
    guid!: string;

    constructor(data?: ISaleMassUpdateJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): SaleMassUpdateJob {
        data = typeof data === 'object' ? data : {};
        let result = new SaleMassUpdateJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface ISaleMassUpdateJob {
    guid: string;
}

export class SaleNotesObject implements ISaleNotesObject {
    ensSaleNoteTid?: number;
    ensSaleTid?: number;
    userFullName?: string | undefined;
    noteContent?: string | undefined;
    noteDateTime?: Date;

    constructor(data?: ISaleNotesObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleNoteTid = _data["ensSaleNoteTid"];
            this.ensSaleTid = _data["ensSaleTid"];
            this.userFullName = _data["userFullName"];
            this.noteContent = _data["noteContent"];
            this.noteDateTime = _data["noteDateTime"] ? new Date(_data["noteDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SaleNotesObject {
        data = typeof data === 'object' ? data : {};
        let result = new SaleNotesObject();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleNoteTid"] = this.ensSaleNoteTid;
        data["ensSaleTid"] = this.ensSaleTid;
        data["userFullName"] = this.userFullName;
        data["noteContent"] = this.noteContent;
        data["noteDateTime"] = this.noteDateTime ? this.noteDateTime.toISOString() : undefined as any;
        return data;
    }
}

export interface ISaleNotesObject {
    ensSaleNoteTid?: number;
    ensSaleTid?: number;
    userFullName?: string | undefined;
    noteContent?: string | undefined;
    noteDateTime?: Date;
}

export class InsertSaleNoteRequest implements IInsertSaleNoteRequest {
    ens_sale_tid!: number;
    ens_user_tid!: number;
    note_content!: string;

    constructor(data?: IInsertSaleNoteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.ens_user_tid = _data["ens_user_tid"];
            this.note_content = _data["note_content"];
        }
    }

    static fromJS(data: any): InsertSaleNoteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InsertSaleNoteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["ens_user_tid"] = this.ens_user_tid;
        data["note_content"] = this.note_content;
        return data;
    }
}

export interface IInsertSaleNoteRequest {
    ens_sale_tid: number;
    ens_user_tid: number;
    note_content: string;
}

export class SalePledgeJob implements ISalePledgeJob {
    guid!: string;

    constructor(data?: ISalePledgeJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): SalePledgeJob {
        data = typeof data === 'object' ? data : {};
        let result = new SalePledgeJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        return data;
    }
}

export interface ISalePledgeJob {
    guid: string;
}

export class SalePolicyHistoryUpdateRequest implements ISalePolicyHistoryUpdateRequest {
    policyNumber?: string | undefined;
    effectiveDate?: Date | undefined;

    constructor(data?: ISalePolicyHistoryUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policyNumber = _data["policyNumber"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SalePolicyHistoryUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalePolicyHistoryUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policyNumber"] = this.policyNumber;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISalePolicyHistoryUpdateRequest {
    policyNumber?: string | undefined;
    effectiveDate?: Date | undefined;
}

export class SalePolicyHistoryResponse implements ISalePolicyHistoryResponse {
    ensSaleCarrierPolicyHistoryTid?: number;
    policyNumber?: string | undefined;
    effectiveDate?: Date | undefined;
    updatedDate?: Date | undefined;

    constructor(data?: ISalePolicyHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleCarrierPolicyHistoryTid = _data["ensSaleCarrierPolicyHistoryTid"];
            this.policyNumber = _data["policyNumber"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SalePolicyHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalePolicyHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleCarrierPolicyHistoryTid"] = this.ensSaleCarrierPolicyHistoryTid;
        data["policyNumber"] = this.policyNumber;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISalePolicyHistoryResponse {
    ensSaleCarrierPolicyHistoryTid?: number;
    policyNumber?: string | undefined;
    effectiveDate?: Date | undefined;
    updatedDate?: Date | undefined;
}

export class SalePolicyUpdateResponse implements ISalePolicyUpdateResponse {
    code?: SalePolicyCode;
    message?: string | undefined;

    constructor(data?: ISalePolicyUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SalePolicyUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SalePolicyUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface ISalePolicyUpdateResponse {
    code?: SalePolicyCode;
    message?: string | undefined;
}

export enum SalePolicyCode {
    SUCCESS = 0,
    NOT_FOUND = 1,
}

export class SalePolicyUpdateRequest implements ISalePolicyUpdateRequest {
    ensSaleTid!: number;
    policyNumber!: string;
    effectiveDate!: Date;

    constructor(data?: ISalePolicyUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleTid = _data["ensSaleTid"];
            this.policyNumber = _data["policyNumber"];
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): SalePolicyUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalePolicyUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleTid"] = this.ensSaleTid;
        data["policyNumber"] = this.policyNumber;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : undefined as any;
        return data;
    }
}

export interface ISalePolicyUpdateRequest {
    ensSaleTid: number;
    policyNumber: string;
    effectiveDate: Date;
}

export class SaleStatus implements ISaleStatus {
    ens_sale_tid!: number;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    insured_gender?: string | undefined;
    age_at_tos!: number;
    premium?: number | undefined;
    premium_multiplier?: number | undefined;
    commission_amount?: number | undefined;
    primary_policy_number?: string | undefined;
    policy_number_history?: PolicyNumberRecord[] | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_email?: string | undefined;
    insured_phone?: string | undefined;
    referral_agent_answer?: string | undefined;
    sale_datetime!: Date;
    effective_date!: Date;
    approval_datetime?: Date | undefined;
    termination_date?: Date | undefined;
    insured_dob?: Date | undefined;
    commission_paid_date?: Date | undefined;
    issued_ens_sale_status_tid!: number;
    current_ens_sale_status_tid!: number;
    rewrite_fl!: boolean;
    external_campaign_name?: string | undefined;
    external_campaign_id?: string | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    product_carrier_name?: string | undefined;
    ens_product_carrier_tid?: number | undefined;
    product_name?: string | undefined;
    ens_product_tid?: number | undefined;
    agent_first_name?: string | undefined;
    agent_last_name?: string | undefined;
    agent_ens_user_tid?: number | undefined;
    referring_agent_first_name?: string | undefined;
    referring_agent_last_name?: string | undefined;
    referral_ens_user_tid?: number | undefined;
    current_age?: number | undefined;
    total_carrier_payment?: number | undefined;
    last_carrier_payment_date?: Date | undefined;
    last_payment_effective_date?: Date | undefined;
    cash_receipts?: SaleCarrierPaymentReceipt[] | undefined;
    medicare_id?: string | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    ens_sale_underwritting_status_name?: string | undefined;
    recent_note?: string | undefined;
    opportunity_id?: string | undefined;

    constructor(data?: ISaleStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.insured_first_name = _data["insured_first_name"];
            this.insured_last_name = _data["insured_last_name"];
            this.insured_address_line1 = _data["insured_address_line1"];
            this.insured_city = _data["insured_city"];
            this.insured_state = _data["insured_state"];
            this.insured_zip = _data["insured_zip"];
            this.insured_gender = _data["insured_gender"];
            this.age_at_tos = _data["age_at_tos"];
            this.premium = _data["premium"];
            this.premium_multiplier = _data["premium_multiplier"];
            this.commission_amount = _data["commission_amount"];
            this.primary_policy_number = _data["primary_policy_number"];
            if (Array.isArray(_data["policy_number_history"])) {
                this.policy_number_history = [] as any;
                for (let item of _data["policy_number_history"])
                    this.policy_number_history!.push(PolicyNumberRecord.fromJS(item));
            }
            this.commission_basis = _data["commission_basis"];
            this.notes = _data["notes"];
            this.underwriting_comments = _data["underwriting_comments"];
            this.insured_email = _data["insured_email"];
            this.insured_phone = _data["insured_phone"];
            this.referral_agent_answer = _data["referral_agent_answer"];
            this.sale_datetime = _data["sale_datetime"] ? new Date(_data["sale_datetime"].toString()) : undefined as any;
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : undefined as any;
            this.approval_datetime = _data["approval_datetime"] ? new Date(_data["approval_datetime"].toString()) : undefined as any;
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : undefined as any;
            this.insured_dob = _data["insured_dob"] ? new Date(_data["insured_dob"].toString()) : undefined as any;
            this.commission_paid_date = _data["commission_paid_date"] ? new Date(_data["commission_paid_date"].toString()) : undefined as any;
            this.issued_ens_sale_status_tid = _data["issued_ens_sale_status_tid"];
            this.current_ens_sale_status_tid = _data["current_ens_sale_status_tid"];
            this.rewrite_fl = _data["rewrite_fl"];
            this.external_campaign_name = _data["external_campaign_name"];
            this.external_campaign_id = _data["external_campaign_id"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.product_carrier_name = _data["product_carrier_name"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.product_name = _data["product_name"];
            this.ens_product_tid = _data["ens_product_tid"];
            this.agent_first_name = _data["agent_first_name"];
            this.agent_last_name = _data["agent_last_name"];
            this.agent_ens_user_tid = _data["agent_ens_user_tid"];
            this.referring_agent_first_name = _data["referring_agent_first_name"];
            this.referring_agent_last_name = _data["referring_agent_last_name"];
            this.referral_ens_user_tid = _data["referral_ens_user_tid"];
            this.current_age = _data["current_age"];
            this.total_carrier_payment = _data["total_carrier_payment"];
            this.last_carrier_payment_date = _data["last_carrier_payment_date"] ? new Date(_data["last_carrier_payment_date"].toString()) : undefined as any;
            this.last_payment_effective_date = _data["last_payment_effective_date"] ? new Date(_data["last_payment_effective_date"].toString()) : undefined as any;
            if (Array.isArray(_data["cash_receipts"])) {
                this.cash_receipts = [] as any;
                for (let item of _data["cash_receipts"])
                    this.cash_receipts!.push(SaleCarrierPaymentReceipt.fromJS(item));
            }
            this.medicare_id = _data["medicare_id"];
            this.ens_sale_underwritting_status_tid = _data["ens_sale_underwritting_status_tid"];
            this.ens_sale_underwritting_status_name = _data["ens_sale_underwritting_status_name"];
            this.recent_note = _data["recent_note"];
            this.opportunity_id = _data["opportunity_id"];
        }
    }

    static fromJS(data: any): SaleStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SaleStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["insured_first_name"] = this.insured_first_name;
        data["insured_last_name"] = this.insured_last_name;
        data["insured_address_line1"] = this.insured_address_line1;
        data["insured_city"] = this.insured_city;
        data["insured_state"] = this.insured_state;
        data["insured_zip"] = this.insured_zip;
        data["insured_gender"] = this.insured_gender;
        data["age_at_tos"] = this.age_at_tos;
        data["premium"] = this.premium;
        data["premium_multiplier"] = this.premium_multiplier;
        data["commission_amount"] = this.commission_amount;
        data["primary_policy_number"] = this.primary_policy_number;
        if (Array.isArray(this.policy_number_history)) {
            data["policy_number_history"] = [];
            for (let item of this.policy_number_history)
                data["policy_number_history"].push(item ? item.toJSON() : undefined as any);
        }
        data["commission_basis"] = this.commission_basis;
        data["notes"] = this.notes;
        data["underwriting_comments"] = this.underwriting_comments;
        data["insured_email"] = this.insured_email;
        data["insured_phone"] = this.insured_phone;
        data["referral_agent_answer"] = this.referral_agent_answer;
        data["sale_datetime"] = this.sale_datetime ? this.sale_datetime.toISOString() : undefined as any;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : undefined as any;
        data["approval_datetime"] = this.approval_datetime ? this.approval_datetime.toISOString() : undefined as any;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : undefined as any;
        data["insured_dob"] = this.insured_dob ? this.insured_dob.toISOString() : undefined as any;
        data["commission_paid_date"] = this.commission_paid_date ? this.commission_paid_date.toISOString() : undefined as any;
        data["issued_ens_sale_status_tid"] = this.issued_ens_sale_status_tid;
        data["current_ens_sale_status_tid"] = this.current_ens_sale_status_tid;
        data["rewrite_fl"] = this.rewrite_fl;
        data["external_campaign_name"] = this.external_campaign_name;
        data["external_campaign_id"] = this.external_campaign_id;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["product_carrier_name"] = this.product_carrier_name;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["product_name"] = this.product_name;
        data["ens_product_tid"] = this.ens_product_tid;
        data["agent_first_name"] = this.agent_first_name;
        data["agent_last_name"] = this.agent_last_name;
        data["agent_ens_user_tid"] = this.agent_ens_user_tid;
        data["referring_agent_first_name"] = this.referring_agent_first_name;
        data["referring_agent_last_name"] = this.referring_agent_last_name;
        data["referral_ens_user_tid"] = this.referral_ens_user_tid;
        data["current_age"] = this.current_age;
        data["total_carrier_payment"] = this.total_carrier_payment;
        data["last_carrier_payment_date"] = this.last_carrier_payment_date ? this.last_carrier_payment_date.toISOString() : undefined as any;
        data["last_payment_effective_date"] = this.last_payment_effective_date ? this.last_payment_effective_date.toISOString() : undefined as any;
        if (Array.isArray(this.cash_receipts)) {
            data["cash_receipts"] = [];
            for (let item of this.cash_receipts)
                data["cash_receipts"].push(item ? item.toJSON() : undefined as any);
        }
        data["medicare_id"] = this.medicare_id;
        data["ens_sale_underwritting_status_tid"] = this.ens_sale_underwritting_status_tid;
        data["ens_sale_underwritting_status_name"] = this.ens_sale_underwritting_status_name;
        data["recent_note"] = this.recent_note;
        data["opportunity_id"] = this.opportunity_id;
        return data;
    }
}

export interface ISaleStatus {
    ens_sale_tid: number;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    insured_gender?: string | undefined;
    age_at_tos: number;
    premium?: number | undefined;
    premium_multiplier?: number | undefined;
    commission_amount?: number | undefined;
    primary_policy_number?: string | undefined;
    policy_number_history?: PolicyNumberRecord[] | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_email?: string | undefined;
    insured_phone?: string | undefined;
    referral_agent_answer?: string | undefined;
    sale_datetime: Date;
    effective_date: Date;
    approval_datetime?: Date | undefined;
    termination_date?: Date | undefined;
    insured_dob?: Date | undefined;
    commission_paid_date?: Date | undefined;
    issued_ens_sale_status_tid: number;
    current_ens_sale_status_tid: number;
    rewrite_fl: boolean;
    external_campaign_name?: string | undefined;
    external_campaign_id?: string | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    product_carrier_name?: string | undefined;
    ens_product_carrier_tid?: number | undefined;
    product_name?: string | undefined;
    ens_product_tid?: number | undefined;
    agent_first_name?: string | undefined;
    agent_last_name?: string | undefined;
    agent_ens_user_tid?: number | undefined;
    referring_agent_first_name?: string | undefined;
    referring_agent_last_name?: string | undefined;
    referral_ens_user_tid?: number | undefined;
    current_age?: number | undefined;
    total_carrier_payment?: number | undefined;
    last_carrier_payment_date?: Date | undefined;
    last_payment_effective_date?: Date | undefined;
    cash_receipts?: SaleCarrierPaymentReceipt[] | undefined;
    medicare_id?: string | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    ens_sale_underwritting_status_name?: string | undefined;
    recent_note?: string | undefined;
    opportunity_id?: string | undefined;
}

export class PolicyNumberRecord implements IPolicyNumberRecord {
    policy_number!: string;
    effective_date?: Date | undefined;
    updated_date?: Date | undefined;

    constructor(data?: IPolicyNumberRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.policy_number = _data["policy_number"];
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : undefined as any;
            this.updated_date = _data["updated_date"] ? new Date(_data["updated_date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): PolicyNumberRecord {
        data = typeof data === 'object' ? data : {};
        let result = new PolicyNumberRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["policy_number"] = this.policy_number;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : undefined as any;
        data["updated_date"] = this.updated_date ? this.updated_date.toISOString() : undefined as any;
        return data;
    }
}

export interface IPolicyNumberRecord {
    policy_number: string;
    effective_date?: Date | undefined;
    updated_date?: Date | undefined;
}

export class SaleCarrierPaymentReceipt implements ISaleCarrierPaymentReceipt {
    paymentDate?: Date;
    paymentEffectiveDate?: Date | undefined;
    paymentAmount?: number | undefined;
    paymentLedgerCategory?: number | undefined;
    debugPolicyNumber?: string | undefined;
    policyEffectiveDate?: Date | undefined;
    isStephenMatthews?: boolean;

    constructor(data?: ISaleCarrierPaymentReceipt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDate = _data["paymentDate"] ? new Date(_data["paymentDate"].toString()) : undefined as any;
            this.paymentEffectiveDate = _data["paymentEffectiveDate"] ? new Date(_data["paymentEffectiveDate"].toString()) : undefined as any;
            this.paymentAmount = _data["paymentAmount"];
            this.paymentLedgerCategory = _data["paymentLedgerCategory"];
            this.debugPolicyNumber = _data["debugPolicyNumber"];
            this.policyEffectiveDate = _data["policyEffectiveDate"] ? new Date(_data["policyEffectiveDate"].toString()) : undefined as any;
            this.isStephenMatthews = _data["isStephenMatthews"];
        }
    }

    static fromJS(data: any): SaleCarrierPaymentReceipt {
        data = typeof data === 'object' ? data : {};
        let result = new SaleCarrierPaymentReceipt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDate"] = this.paymentDate ? this.paymentDate.toISOString() : undefined as any;
        data["paymentEffectiveDate"] = this.paymentEffectiveDate ? this.paymentEffectiveDate.toISOString() : undefined as any;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentLedgerCategory"] = this.paymentLedgerCategory;
        data["debugPolicyNumber"] = this.debugPolicyNumber;
        data["policyEffectiveDate"] = this.policyEffectiveDate ? this.policyEffectiveDate.toISOString() : undefined as any;
        data["isStephenMatthews"] = this.isStephenMatthews;
        return data;
    }
}

export interface ISaleCarrierPaymentReceipt {
    paymentDate?: Date;
    paymentEffectiveDate?: Date | undefined;
    paymentAmount?: number | undefined;
    paymentLedgerCategory?: number | undefined;
    debugPolicyNumber?: string | undefined;
    policyEffectiveDate?: Date | undefined;
    isStephenMatthews?: boolean;
}

export class SalesStatusSearchRequest implements ISalesStatusSearchRequest {
    ensSaleTid?: number | undefined;
    resultsLimit?: number | undefined;
    agentId?: number | undefined;
    carrierId?: number | undefined;
    startDateUnixMilli?: number | undefined;
    endDateUnixMilli?: number | undefined;
    issueSaleStatus?: number | undefined;
    currentSaleStatus?: number | undefined;
    productId?: number | undefined;
    referralAgent?: number | undefined;
    insuredFirstName?: string | undefined;
    insuredLastName?: string | undefined;
    insuredPhoneNumber?: string | undefined;
    repPaidStartDateUnixMilli?: number | undefined;
    repPaidEndDateUnixMilli?: number | undefined;
    approvalStartDateUnixMilli?: number | undefined;
    approvalEndDateUnixMilli?: number | undefined;
    insuredState?: string | undefined;
    terminationDateUnixMilli?: number | undefined;
    policyNumber?: string | undefined;
    medicareId?: string | undefined;
    getSaleNotes?: boolean | undefined;
    opportunityId?: string | undefined;
    ensSaleUnderwrittingStatusTid?: number | undefined;

    constructor(data?: ISalesStatusSearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleTid = _data["ensSaleTid"];
            this.resultsLimit = _data["resultsLimit"];
            this.agentId = _data["agentId"];
            this.carrierId = _data["carrierId"];
            this.startDateUnixMilli = _data["startDateUnixMilli"];
            this.endDateUnixMilli = _data["endDateUnixMilli"];
            this.issueSaleStatus = _data["issueSaleStatus"];
            this.currentSaleStatus = _data["currentSaleStatus"];
            this.productId = _data["productId"];
            this.referralAgent = _data["referralAgent"];
            this.insuredFirstName = _data["insuredFirstName"];
            this.insuredLastName = _data["insuredLastName"];
            this.insuredPhoneNumber = _data["insuredPhoneNumber"];
            this.repPaidStartDateUnixMilli = _data["repPaidStartDateUnixMilli"];
            this.repPaidEndDateUnixMilli = _data["repPaidEndDateUnixMilli"];
            this.approvalStartDateUnixMilli = _data["approvalStartDateUnixMilli"];
            this.approvalEndDateUnixMilli = _data["approvalEndDateUnixMilli"];
            this.insuredState = _data["insuredState"];
            this.terminationDateUnixMilli = _data["terminationDateUnixMilli"];
            this.policyNumber = _data["policyNumber"];
            this.medicareId = _data["medicareId"];
            this.getSaleNotes = _data["getSaleNotes"];
            this.opportunityId = _data["opportunityId"];
            this.ensSaleUnderwrittingStatusTid = _data["ensSaleUnderwrittingStatusTid"];
        }
    }

    static fromJS(data: any): SalesStatusSearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SalesStatusSearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleTid"] = this.ensSaleTid;
        data["resultsLimit"] = this.resultsLimit;
        data["agentId"] = this.agentId;
        data["carrierId"] = this.carrierId;
        data["startDateUnixMilli"] = this.startDateUnixMilli;
        data["endDateUnixMilli"] = this.endDateUnixMilli;
        data["issueSaleStatus"] = this.issueSaleStatus;
        data["currentSaleStatus"] = this.currentSaleStatus;
        data["productId"] = this.productId;
        data["referralAgent"] = this.referralAgent;
        data["insuredFirstName"] = this.insuredFirstName;
        data["insuredLastName"] = this.insuredLastName;
        data["insuredPhoneNumber"] = this.insuredPhoneNumber;
        data["repPaidStartDateUnixMilli"] = this.repPaidStartDateUnixMilli;
        data["repPaidEndDateUnixMilli"] = this.repPaidEndDateUnixMilli;
        data["approvalStartDateUnixMilli"] = this.approvalStartDateUnixMilli;
        data["approvalEndDateUnixMilli"] = this.approvalEndDateUnixMilli;
        data["insuredState"] = this.insuredState;
        data["terminationDateUnixMilli"] = this.terminationDateUnixMilli;
        data["policyNumber"] = this.policyNumber;
        data["medicareId"] = this.medicareId;
        data["getSaleNotes"] = this.getSaleNotes;
        data["opportunityId"] = this.opportunityId;
        data["ensSaleUnderwrittingStatusTid"] = this.ensSaleUnderwrittingStatusTid;
        return data;
    }
}

export interface ISalesStatusSearchRequest {
    ensSaleTid?: number | undefined;
    resultsLimit?: number | undefined;
    agentId?: number | undefined;
    carrierId?: number | undefined;
    startDateUnixMilli?: number | undefined;
    endDateUnixMilli?: number | undefined;
    issueSaleStatus?: number | undefined;
    currentSaleStatus?: number | undefined;
    productId?: number | undefined;
    referralAgent?: number | undefined;
    insuredFirstName?: string | undefined;
    insuredLastName?: string | undefined;
    insuredPhoneNumber?: string | undefined;
    repPaidStartDateUnixMilli?: number | undefined;
    repPaidEndDateUnixMilli?: number | undefined;
    approvalStartDateUnixMilli?: number | undefined;
    approvalEndDateUnixMilli?: number | undefined;
    insuredState?: string | undefined;
    terminationDateUnixMilli?: number | undefined;
    policyNumber?: string | undefined;
    medicareId?: string | undefined;
    getSaleNotes?: boolean | undefined;
    opportunityId?: string | undefined;
    ensSaleUnderwrittingStatusTid?: number | undefined;
}

export class SaleUpdateRequest implements ISaleUpdateRequest {
    ens_sale_tid?: number;
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid?: number | undefined;
    ens_product_tid?: number | undefined;
    agent_ens_user_tid?: number | undefined;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    sale_datetime?: Date | undefined;
    effective_date?: Date | undefined;
    age_at_tos?: number | undefined;
    premium?: number | undefined;
    premium_multiplier?: number | undefined;
    rewrite_fl?: boolean | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob?: Date | undefined;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    current_ens_sale_status_tid?: number | undefined;
    issued_ens_sale_status_tid?: number | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    medicare_id?: string | undefined;

    constructor(data?: ISaleUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.purchaser_last_ens_contact_marketing_action_tid = _data["purchaser_last_ens_contact_marketing_action_tid"];
            this.purchaser_ens_contact_id = _data["purchaser_ens_contact_id"];
            this.insured_ens_contact_tid = _data["insured_ens_contact_tid"];
            this.ens_product_carrier_tid = _data["ens_product_carrier_tid"];
            this.ens_product_tid = _data["ens_product_tid"];
            this.agent_ens_user_tid = _data["agent_ens_user_tid"];
            this.referral_ens_user_tid = _data["referral_ens_user_tid"];
            this.f9_worksheet_tid = _data["f9_worksheet_tid"];
            this.sale_datetime = _data["sale_datetime"] ? new Date(_data["sale_datetime"].toString()) : undefined as any;
            this.effective_date = _data["effective_date"] ? new Date(_data["effective_date"].toString()) : undefined as any;
            this.age_at_tos = _data["age_at_tos"];
            this.premium = _data["premium"];
            this.premium_multiplier = _data["premium_multiplier"];
            this.rewrite_fl = _data["rewrite_fl"];
            this.referral_agent_answer = _data["referral_agent_answer"];
            this.primary_policy_number = _data["primary_policy_number"];
            this.commission_basis = _data["commission_basis"];
            this.notes = _data["notes"];
            this.underwriting_comments = _data["underwriting_comments"];
            this.insured_first_name = _data["insured_first_name"];
            this.insured_last_name = _data["insured_last_name"];
            this.insured_gender = _data["insured_gender"];
            this.insured_dob = _data["insured_dob"] ? new Date(_data["insured_dob"].toString()) : undefined as any;
            this.insured_phone = _data["insured_phone"];
            this.insured_email = _data["insured_email"];
            this.insured_address_line1 = _data["insured_address_line1"];
            this.insured_address_line2 = _data["insured_address_line2"];
            this.insured_city = _data["insured_city"];
            this.insured_state = _data["insured_state"];
            this.insured_zip = _data["insured_zip"];
            this.approval_datetime = _data["approval_datetime"] ? new Date(_data["approval_datetime"].toString()) : undefined as any;
            this.current_ens_sale_status_tid = _data["current_ens_sale_status_tid"];
            this.issued_ens_sale_status_tid = _data["issued_ens_sale_status_tid"];
            this.termination_date = _data["termination_date"] ? new Date(_data["termination_date"].toString()) : undefined as any;
            this.ens_sale_underwritting_status_tid = _data["ens_sale_underwritting_status_tid"];
            this.ens_marketing_campaign_tid = _data["ens_marketing_campaign_tid"];
            this.medicare_id = _data["medicare_id"];
        }
    }

    static fromJS(data: any): SaleUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaleUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["purchaser_last_ens_contact_marketing_action_tid"] = this.purchaser_last_ens_contact_marketing_action_tid;
        data["purchaser_ens_contact_id"] = this.purchaser_ens_contact_id;
        data["insured_ens_contact_tid"] = this.insured_ens_contact_tid;
        data["ens_product_carrier_tid"] = this.ens_product_carrier_tid;
        data["ens_product_tid"] = this.ens_product_tid;
        data["agent_ens_user_tid"] = this.agent_ens_user_tid;
        data["referral_ens_user_tid"] = this.referral_ens_user_tid;
        data["f9_worksheet_tid"] = this.f9_worksheet_tid;
        data["sale_datetime"] = this.sale_datetime ? this.sale_datetime.toISOString() : undefined as any;
        data["effective_date"] = this.effective_date ? this.effective_date.toISOString() : undefined as any;
        data["age_at_tos"] = this.age_at_tos;
        data["premium"] = this.premium;
        data["premium_multiplier"] = this.premium_multiplier;
        data["rewrite_fl"] = this.rewrite_fl;
        data["referral_agent_answer"] = this.referral_agent_answer;
        data["primary_policy_number"] = this.primary_policy_number;
        data["commission_basis"] = this.commission_basis;
        data["notes"] = this.notes;
        data["underwriting_comments"] = this.underwriting_comments;
        data["insured_first_name"] = this.insured_first_name;
        data["insured_last_name"] = this.insured_last_name;
        data["insured_gender"] = this.insured_gender;
        data["insured_dob"] = this.insured_dob ? this.insured_dob.toISOString() : undefined as any;
        data["insured_phone"] = this.insured_phone;
        data["insured_email"] = this.insured_email;
        data["insured_address_line1"] = this.insured_address_line1;
        data["insured_address_line2"] = this.insured_address_line2;
        data["insured_city"] = this.insured_city;
        data["insured_state"] = this.insured_state;
        data["insured_zip"] = this.insured_zip;
        data["approval_datetime"] = this.approval_datetime ? this.approval_datetime.toISOString() : undefined as any;
        data["current_ens_sale_status_tid"] = this.current_ens_sale_status_tid;
        data["issued_ens_sale_status_tid"] = this.issued_ens_sale_status_tid;
        data["termination_date"] = this.termination_date ? this.termination_date.toISOString() : undefined as any;
        data["ens_sale_underwritting_status_tid"] = this.ens_sale_underwritting_status_tid;
        data["ens_marketing_campaign_tid"] = this.ens_marketing_campaign_tid;
        data["medicare_id"] = this.medicare_id;
        return data;
    }
}

export interface ISaleUpdateRequest {
    ens_sale_tid?: number;
    purchaser_last_ens_contact_marketing_action_tid?: number | undefined;
    purchaser_ens_contact_id?: number | undefined;
    insured_ens_contact_tid?: number | undefined;
    ens_product_carrier_tid?: number | undefined;
    ens_product_tid?: number | undefined;
    agent_ens_user_tid?: number | undefined;
    referral_ens_user_tid?: number | undefined;
    f9_worksheet_tid?: number | undefined;
    sale_datetime?: Date | undefined;
    effective_date?: Date | undefined;
    age_at_tos?: number | undefined;
    premium?: number | undefined;
    premium_multiplier?: number | undefined;
    rewrite_fl?: boolean | undefined;
    referral_agent_answer?: string | undefined;
    primary_policy_number?: string | undefined;
    commission_basis?: string | undefined;
    notes?: string | undefined;
    underwriting_comments?: string | undefined;
    insured_first_name?: string | undefined;
    insured_last_name?: string | undefined;
    insured_gender?: string | undefined;
    insured_dob?: Date | undefined;
    insured_phone?: string | undefined;
    insured_email?: string | undefined;
    insured_address_line1?: string | undefined;
    insured_address_line2?: string | undefined;
    insured_city?: string | undefined;
    insured_state?: string | undefined;
    insured_zip?: string | undefined;
    approval_datetime?: Date | undefined;
    current_ens_sale_status_tid?: number | undefined;
    issued_ens_sale_status_tid?: number | undefined;
    termination_date?: Date | undefined;
    ens_sale_underwritting_status_tid?: number | undefined;
    ens_marketing_campaign_tid?: number | undefined;
    medicare_id?: string | undefined;
}

export class SaleStatusUpdateRequest implements ISaleStatusUpdateRequest {
    calling_user!: string;
    current_status_tid?: EnsSaleStatusTid | undefined;
    issue_status_tid?: EnsSaleStatusTid | undefined;

    constructor(data?: ISaleStatusUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calling_user = _data["calling_user"];
            this.current_status_tid = _data["current_status_tid"];
            this.issue_status_tid = _data["issue_status_tid"];
        }
    }

    static fromJS(data: any): SaleStatusUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SaleStatusUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calling_user"] = this.calling_user;
        data["current_status_tid"] = this.current_status_tid;
        data["issue_status_tid"] = this.issue_status_tid;
        return data;
    }
}

export interface ISaleStatusUpdateRequest {
    calling_user: string;
    current_status_tid?: EnsSaleStatusTid | undefined;
    issue_status_tid?: EnsSaleStatusTid | undefined;
}

export enum EnsSaleStatusTid {
    Cancelled = 1,
    Deleted = 2,
    Duplicate = 3,
    Incomplete = 4,
    Issued = 5,
    Lapsed = 6,
    NTO = 7,
    Pending = 8,
    PendingCms = 9,
    Rejected = 10,
    RapidDisenrollment = 11,
    Terminated = 12,
    Error = -1,
}

export class SaleStatusUpdateRequestBulk implements ISaleStatusUpdateRequestBulk {
    ens_sale_tid!: number;
    request!: SaleStatusUpdateRequest;

    constructor(data?: ISaleStatusUpdateRequestBulk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.request = new SaleStatusUpdateRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ens_sale_tid = _data["ens_sale_tid"];
            this.request = _data["request"] ? SaleStatusUpdateRequest.fromJS(_data["request"]) : new SaleStatusUpdateRequest();
        }
    }

    static fromJS(data: any): SaleStatusUpdateRequestBulk {
        data = typeof data === 'object' ? data : {};
        let result = new SaleStatusUpdateRequestBulk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ens_sale_tid"] = this.ens_sale_tid;
        data["request"] = this.request ? this.request.toJSON() : undefined as any;
        return data;
    }
}

export interface ISaleStatusUpdateRequestBulk {
    ens_sale_tid: number;
    request: SaleStatusUpdateRequest;
}

export class UnderwritingStatusResponse implements IUnderwritingStatusResponse {
    ensSaleUnderwrittingStatusTid!: number;
    name!: string;
    activeFl!: boolean;

    constructor(data?: IUnderwritingStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ensSaleUnderwrittingStatusTid = _data["ensSaleUnderwrittingStatusTid"];
            this.name = _data["name"];
            this.activeFl = _data["activeFl"];
        }
    }

    static fromJS(data: any): UnderwritingStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnderwritingStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ensSaleUnderwrittingStatusTid"] = this.ensSaleUnderwrittingStatusTid;
        data["name"] = this.name;
        data["activeFl"] = this.activeFl;
        return data;
    }
}

export interface IUnderwritingStatusResponse {
    ensSaleUnderwrittingStatusTid: number;
    name: string;
    activeFl: boolean;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}